/* eslint-disable */
// en.js
export const locale = {
  GENERAL: {
    NAV_OPTIONS: ['Home', 'Ye De-hui \'s Biography', 'Introduction', 'Individual Biographies', 'Collections', 'Visualizations', 'Search', 'Individual Studies'],
    WELCOME_WORD: 'Welcome to your Vue.js application', // for main content
  },
}
